module.exports = __webpack_public_path__ + "static/media/tyre-high.0d04a96d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/tyre-high.png
// module id = 5
// module chunks = 0